import {NavItem} from "../components/FormNav/NavItem";
import FormPages from "./FormPages";
import {NavItemType} from "../components/FormNav/NavItemType";

export const WILL_BASE_URL = "/Profile/${id}/ClientProfile/EstateFlowchart/${flowchartId}/Will/${estateItemId}/";

export const WillFormPages: NavItem[] = [
    {
        id: FormPages.BASIC_INFORMATION.id,
        displayName: FormPages.BASIC_INFORMATION.displayName,
        type: NavItemType.PAGE,
        index: 0,
        pathTemplate: WILL_BASE_URL + FormPages.BASIC_INFORMATION.id
    } as NavItem
]